module.exports = __webpack_public_path__ + "resources/img/img_secureguard_pm3_m.a18750cc75a76f16f11c2f8ac3f19331.png";